import { ApplicationConfig, mergeApplicationConfig } from '@angular/core';
/* import { provideClientHydration } from '@angular/platform-browser'; */
import { provideAnimations } from '@angular/platform-browser/animations';
import { UrlSerializer } from '@angular/router';
import { complex_links, organization_name } from 'ctt-babylon';
import { commonConfig } from './app.config.common';
import { environment } from './environments/environment';
import { TrailingSlashUrlSerializer } from './services/routes/trailing-slash.serializer';

export const appConfig: ApplicationConfig = mergeApplicationConfig(
    commonConfig,
    {
        providers: [
            provideAnimations(),
            {
                provide: complex_links,
                useValue: environment.menuComplexLinks,
            },
            {
                provide: organization_name,
                useValue: environment.organizationName,
            },
            { provide: UrlSerializer, useClass: TrailingSlashUrlSerializer },
        ],
    }
);
